var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Caution"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8797 17.1473L12.6892 5.92839C12.374 5.3572 11.626 5.3572 11.3108 5.92839L5.12032 17.1473C4.75547 17.8085 5.25543 18.5 5.80953 18.5H18.1905C18.7446 18.5 19.2445 17.8085 18.8797 17.1473ZM10.4352 5.44527C11.1307 4.18491 12.8693 4.18491 13.5648 5.44527L19.7552 16.6642C20.4507 17.9246 19.5814 19.5 18.1905 19.5H5.80953C4.41863 19.5 3.54931 17.9245 4.24477 16.6642L10.4352 5.44527Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5L11.5 14.5L11.5 10L12.5 10L12.5 14.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.5L11.5 16.5L11.5 15.5L12.5 15.5L12.5 16.5Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.5e683251886f067c466210779d357d50.svg";
export { ForwardRef as ReactComponent };